<template>
  <div class="homeContainer">
    <div style="width: 74%" v-show="authorityType != '三方公司'">
      <div class="proStyle">
        <h3>员工统计</h3>
        <proDayData />
      </div>
      <div class="modelTop">
        <div style="width: 70%">
          <!-- 结算 -->
          <section v-show="authorityType != '三方公司'" class="totalAccount">
            <ul>
              <li style="background: #eaf2ff">
                <!-- <img src="../../assets/home/icon1.png" alt /> -->
                <div>
                  <p>
                    <strong v-if="data != ''">{{ data.total_work }}</strong>
                  </p>
                  <p>在职人数</p>
                </div>
              </li>
              <li style="background: #f9f5fe">
                <!-- <img src="../../assets/home/icon2.png" alt /> -->
                <div>
                  <p>
                    <strong v-if="data != ''">{{
                      data.total_work_no_identity
                    }}</strong>
                  </p>
                  <p>在职未认证</p>
                </div>
              </li>
              <li style="background: #fef6fb">
                <!-- <img src="../../assets/home/icon3.png" alt /> -->
                <div>
                  <p>
                    <strong v-if="data != ''">{{
                      data.total_work_no_sign
                    }}</strong>
                  </p>
                  <p>在职未签约</p>
                </div>
              </li>
            </ul>
          </section>
          <!-- 结算  end -->
          <!-- 日历 -->
          <section v-show="authorityType != '三方公司'" class="todayData">
            <h3 class="checkDate">
              <a-tabs :default-active-key="4" @change="checkDate">
                <a-tab-pane :key="1" tab="今日" />
                <a-tab-pane :key="2" tab="昨日" />
                <a-tab-pane :key="3" tab="本周" />
                <a-tab-pane :key="4" tab="本月" />
                <a-tab-pane :key="5" tab="本年度" />
                <a-tab-pane :key="6" tab="历史" />
              </a-tabs>
            </h3>
            <div class="rangingStyle">
              <p>排名</p>
              <p>姓名</p>
              <p
                class="onClick"
                v-for="(item, k) in onRankTab"
                :key="k"
                :style="item.isAddColor ? 'color:#ea5413;font-weight:bold' : ''"
                @click="onRank(k)"
              >
                {{ item.label }}
              </p>
            </div>
            <ul class="ranging">
              <li v-for="(item, k) in rankingList.data" :key="k">
                <p>
                  <img
                    v-show="k == 0"
                    src="../../assets/home/gold.png"
                    alt=""
                  />
                  <img
                    v-show="k == 1"
                    src="../../assets/home/silver.png"
                    alt=""
                  />
                  <img
                    v-show="k == 2"
                    src="../../assets/home/copper.png"
                    alt=""
                  />
                  <span v-show="k > 2">{{ k + 1 }}</span>
                </p>
                <p>{{ item.user_name }}</p>
                <p>{{ item.new_resume }}</p>
                <p>{{ item.face }}</p>
                <p>{{ item.face_visit }}</p>
                <p>{{ item.entry }}</p>
                <p>{{ item.leave }}</p>
              </li>
            </ul>
          </section>
        </div>
        <!-- 天气 -->
        <section
          class="weather"
          style="width: 28.5%; margin-left: 1.5%;overflow-x: hidden"
        >
          <h3>天气</h3>
          <weather />
        </section>
      </div>
    </div>
    <div
      style="width: 25%; margin-left: 1%"
      v-show="authorityType != '三方公司'"
    >
      <section class="messagesList">
        <h3>系统消息</h3>
        <div style="height: 240px">
          <news />
        </div>
      </section>
      <!-- 日历 -->
      <section class="calendar">
        <h3>日历</h3>
        <a-calendar :fullscreen="false" />
      </section>
    </div>

    <!-- 三方首页 -->
    <section v-show="authorityType == '三方公司'" class="noData">
      <img src="../../assets/home/fighting.jpg" alt />
    </section>
    <!-- 三方首页 end -->
  </div>
</template>
<script>
import axios from "axios";
import weather from "@/components/charts/weather"; //天气
import proDayData from "@/components/charts/proDayData"; //项目数据
import news from "@/components/charts/news"; //系统消息
import moment from "moment";
export default {
  data() {
    return {
      data: "",
      hideIsSend: false,
      authorityType: "",
      rankingList: "",
      order_field: 4,
      type: 4,
      onRankTab: [
        {
          isAddColor: false,
          label: "新增简历",
          id: 1
        },
        {
          isAddColor: false,
          label: "到面",
          id: 2
        },
        {
          isAddColor: false,
          label: "面访",
          id: 3
        },
        {
          isAddColor: true,
          label: "入职",
          id: 4
        },
        {
          isAddColor: false,
          label: "离职",
          id: 5
        }
      ]
    };
  },
  mounted() {
    this.authorityType = localStorage.getItem("xnserve-authority-type");
    // console.log(moment().format("HH"));
    this.getData(); //获取数据
    this.getRanking(); //排行榜
  },
  components: {
    weather,
    proDayData,
    news
  },
  methods: {
    checkDate(index) {
      this.type = index;
      this.getRanking();
    },
    onRank(key) {
      this.onRankTab.forEach(element => {
        element.isAddColor = false;
      });
      // this.myDate = this.onRankTab[key].label;
      this.order_field = this.onRankTab[key].id;
      this.onRankTab[key].isAddColor = !this.onRankTab[key].isAddColor;
      this.getRanking();
      // console.log(key);
    },
    getRanking() {
      let url =
        this.httpsBasic.url + this.httpsBasic.user + "User/rankListData";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        type: this.type,
        order_field: this.order_field
      };
      axios.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.rankingList = res.data.data;
        }
      });
    },
    getData() {
      let url =
        this.httpsBasic.url + this.httpsBasic.trade + "Project/countTwo";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.data = res.data.data.count_data;
          }
        });
    },
    hideInSend() {
      this.hideIsSend = false;
      this.reload();
    }
  }
};
</script>
<style lang="less" scoped>
.proStyle {
  background: #fff;
  overflow-x: hidden;
}
.calendar {
  background: #fff;
  margin-top: 14px;
  min-height: 340px;
  height: 350px;
  overflow: hidden;
}
.selectDate {
  padding: 20px 10px;
  border-bottom: 1px solid #f0f2f5;
}
.breadcrumb {
  padding: 14px 0 10px;
  border-bottom: 1px solid #f0f2f5;
}
ol,
ul,
dl {
  margin: 0;
}
.homeContainer {
  margin: 20px 2%;
  min-height: 80vh;
  h3 {
    border-bottom: 1px solid #f0f2f5;
    padding: 10px 6px;
    text-indent: 10px;
    font-weight: normal;
    font-size: 14px;
  }
  .messagesList {
    background: #fff;
    padding: 0 10px;
    ul {
      height: 260px;
    }
  }
  > div {
    display: inline-block;
    vertical-align: top;
  }
  // background: #fff;
  .title {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    // border-bottom: 1px solid #f0f2f5;
    // margin-bottom: 20px;
    h3 {
      font-size: 16px;
      margin-bottom: 0;
      font-weight: normal;
      // padding-bottom: 10px;
    }
  }
  .totalAccount {
    background: #fff;
    padding: 10px 2%;
    text-align: center;
    > ul {
      // border-bottom: 1px solid #f0f2f5;
      // padding-bottom: 20px;

      // width: 70%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      > li {
        border-radius: 4px;
        padding: 10px;
        min-height: 66px;
        width: 32%;
        img {
          height: 20px;
          display: inline-block;
          margin-right: 10px;
        }
        p {
          line-height: 22px;
          font-size: 14px;
        }
        strong {
          font-size: 16px;
          color: #f56c6c;
          line-height: 22px;
        }
      }
    }
  }
  .noData {
    padding: 30px 4%;
    background: #fff;
    min-height: 82vh;
    text-align: center;
    p {
      font-size: 24px;
      text-align: left;
    }
    img {
      height: 400px;
      margin: 50px auto 0;
    }
  }
  .modelTop {
    > div {
      display: inline-block;
      vertical-align: top;
    }
  }
  .weather {
    background: #fff;
    min-height: 350px;
  }
  .todayData {
    // width: 50%;
    background: #fff;
    margin: 12px 0;
    min-height: 232px;
    padding-bottom: 10px;
    h3 {
      padding: 0 10px;
    }
    .rangingStyle {
      // width: 100%;
      margin: 0 2%;
      padding-right: 16px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      .onClick {
        cursor: pointer;
      }
      p {
        font-size: 12px;
        line-height: 20px;
        text-align: center;
        padding: 6px;
        min-width: 12%;
      }
    }
    .ranging {
      width: 96%;
      margin: 0 2%;
      height: 160px;
      overflow-y: scroll;

      > li {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        p {
          font-size: 12px;
          line-height: 20px;
          text-align: center;
          padding: 6px;
          min-width: 12%;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          color: #666;
        }
        // p:first-child,
        // p:nth-child(2) {
        //   color: #333;
        //   font-weight: bold;
        // }
        img {
          height: 16px;
        }
      }
    }
  }
  .operation {
    width: 100%;
    padding: 20px 2% 10px;
    background: #fff;
    > div {
      > div {
        width: 50%;
        display: inline-block;
      }
    }
  }

  .modelTop {
    margin-top: 14px;
    > div,
    > section {
      display: inline-block;
      vertical-align: top;
    }
  }
}
</style>
<style lang="less">
.homeContainer {
  .ant-tabs-bar {
    border-bottom: none;
    margin: 0;
  }
}
</style>
